import { Storage } from "aws-amplify";


const StorageGet = async (file) => {
    // console.log("storage get", file)

    
    try {
        await Storage.get(file, { level: 'private', download: true });

    } catch (error) {
        // console.log("ERROR", error)
      
        if(`${error}` === 'Error: Network Error'){

        } else {
        return false
        }
    }

    try {
        const data = await Storage.get(file, { level: 'private'});
        // console.log('str data', data) 
        return data
        
    } catch (error) {
        // console.log('error', error);
        return false
    }



}

export default StorageGet